import Logo from './lizen_logo.jpeg'
import "./TopMenu.scss"
import { Icon } from "semantic-ui-react"
import { useAuth, useChat } from '../../../hooks'
import { Notification } from "../../Common";
import { getPermissions } from "../../Common/Permissions";

export function TopMenu () {
    const {auth,logout} = useAuth()
    const {toggle: toggleChat, pendiente: chatPendiente} = useChat()
    const mostrarChat = Boolean(auth?.me) && getPermissions('use_chatbot', auth)

    const renderName = () =>{
        if(auth?.me?.username){
            return auth.me.username
        }
    }
  return (
    <div className="navbar">
      <div className="brand">
        <div className="logo">
          <img src={Logo} alt='Lizen' className='top-menu-admin__izq__logo' />
        </div>
      </div>
      <div className="navbar__right">
        <span className="navbar__username" title={renderName()}>Hola {renderName()}</span>
        <div className="navbar__actions">
          <div className="navbar__notification-wrapper">
            <Notification />
          </div>
          {mostrarChat && (
            <button type="button" className={`navbar__chat ${chatPendiente ? 'navbar__chat--pendiente' : ''}`} onClick={toggleChat} aria-label="Asistente de consultas" title="Asistente de consultas">
              <Icon name='comments outline' className='top-menu-admin__color_brown' />
            </button>
          )}
          <button type="button" className="navbar__logout" onClick={logout} aria-label="Cerrar sesión" title="Cerrar sesión">
            <Icon name='sign-out' className='top-menu-admin__color_brown' />
          </button>
        </div>
      </div>
    </div>
  );
};



